 <template>
  <div class="box4">
    <pageTitle
      title="覆盖多个热门业务场景<br/>解决垂直领域业务痛点"
      titleColor="#081745"
    />
    <div class="content">
      <div class="item">
        <!-- <i>第1周</i> -->
        <span>
          <h1>大模型入门</h1>
          <p>
            <i>·</i>
            <em>前置基础</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型基础知识</em>
          </p>
        </span>
      </div>
      <div class="item">
        <!-- <i>第2周</i> -->
        <span>
          <h1>大模型应用初体验</h1>
          <p>
            <i>·</i>
            <em>AI应用工具集</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型PromptEngineering原<br />理与实践</em>
          </p>
          <p>
            <i>·</i>
            <em>企业级大模型定制平台</em>
          </p>
        </span>
      </div>
      <div class="item">
        <!-- <i>第3周</i> -->
        <span>
          <h1>大模型初级开发阶段</h1>
          <p>
            <i>·</i>
            <em>Function Call的原理及实践</em>
          </p>
          <p>
            <i>·</i>
            <em>GPTs与Assistant API原理及应用</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型Agent的原理及实践</em>
          </p>
        </span>
      </div>
      <div class="item">
        <!-- <i>第5周</i> -->
        <span>
          <h1>大模型高级开发阶段</h1>
          <p>
            <i>·</i>
            <em>提示词工程实战【金融】</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型平台应用实战【电商】</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型知识库应用实战【物流】</em>
          </p>
          <p>
            <i>·</i>
            <em>大模型微调实战【大健康、新零售、新媒体】</em>
          </p>
        </span>
      </div>
      <div class="item">
        <!-- <i>第5周</i> -->
        <a @click="show = true">查看案例</a>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">以“社交媒体行业-信息抽取场景”为例</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="block-bottom">
          <div class="top">
            <h1>基于规则/机器学习的传统解决方案</h1>
            <span>
              <div>
                <p>
                  <img src="../../../assets/coursePage/ai2/box4/close.png" />
                  <i>无法准确捕捉用户兴趣</i>
                </p>
                <p>
                  <img src="../../../assets/coursePage/ai2/box4/down.png" />
                  <i>提炼信息精准度低</i>
                </p>
                <p>
                  <img src="../../../assets/coursePage/ai2/box4/down.png" />
                  <i>用户粘度低</i>
                </p>
              </div>
              <div>
                <p>
                  <img src="../../../assets/coursePage/ai2/box4/close.png" />
                  <i>不懂/不理解用户</i>
                </p>

                <p>
                  <img src="../../../assets/coursePage/ai2/box4/down.png" />
                  <i>用户体验感差</i>
                </p>
              </div>
            </span>
          </div>
          <div class="bottom">
            <div class="bottomLeft">
              <h1>大模型解决方案</h1>
              <p>
                <img src="../../../assets/coursePage/ai2/box4/corrent.png" />
                <i>关键信息精准抽取</i>
              </p>
              <p>
                <img src="../../../assets/coursePage/ai2/box4/corrent.png" />
                <i>更懂/更理解用户</i>
              </p>
              <p>
                <img src="../../../assets/coursePage/ai2/box4/up.png" />
                <i>推荐信息匹配度更高</i>
              </p>
              <p>
                <img src="../../../assets/coursePage/ai2/box4/up.png" />
                <i>提升20%用户体验感</i>
              </p>
              <p>
                <img src="../../../assets/coursePage/ai2/box4/up.png" />
                <i>增强25%用户粘度</i>
              </p>
            </div>
            <div class="bottomRight">
              <h1>大模型调优</h1>
              <div class="center">
                <p>原始数据</p>
                <p>数据处理</p>
                <p>模型构建</p>
                <p>模型评估</p>
                <p>模型上线</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      show: false,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
i,
em {
  font-style: normal;
}
/deep/ .van-popup--bottom {
}
.block {
  position: relative;
  height: 1370px;
  padding: 0px 48px;
  padding-top: 0px;

  background: #ffffff;

  border-radius: 20px;

  box-sizing: border-box;

  .block-tops {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;

    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    align-items: center;
    height: 132px;
    padding-top: 16px;
    .title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 52px;
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
  }
  .block-bottom {
    margin-top: 28px;

    .top {
      width: 630px;
      height: 600px;
      margin: 0 auto;
      box-shadow: 0px 20px 20px 0px #e2ebff;
      border-radius: 20px;

      box-sizing: border-box;
      border: 2px solid #ffffff;
      > h1 {
        height: 64px;
        background: linear-gradient(270deg, #afb9cf 0%, #828eaa 100%);
        border-radius: 20px 20px 0px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #ffffff;
        line-height: 64px;
        text-align: center;
        font-style: normal;
      }
      > span {
        padding: 0 28px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
        > div {
          p {
            display: flex;
            min-width: 30%;
            margin-bottom: 30px;
            img {
              width: 28px;
              height: 28px;
              margin-right: 12px;
            }
            i {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #081745;
              opacity: 0.5;
              line-height: 36px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
    }
    .bottom {
      background: url("../../../assets/coursePage/ai2/box4/bg02.png") no-repeat;
      background-size: cover;
      width: 790px;
      height: 1006px;
      position: absolute;
      bottom: 0;
      left: -20px;
      padding: 376px 80px 32px;
      box-sizing: border-box;
      display: flex;

      .bottomLeft {
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 36px;
          color: #ffffff;
          line-height: 50px;
          text-align: left;
          font-style: normal;
          margin-bottom: 38px;
        }
        p {
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          img {
            width: 28px;
            height: 28px;
            margin-right: 16px;
          }
          i {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px;
            color: #ffffff;
            line-height: 40px;
            text-align: left;
            font-style: normal;
          }
        }
      }
      .bottomRight {
        margin-left: 110px;
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #ff5d04;
          line-height: 44px;
          text-align: center;
          font-style: normal;
        }
        .center {
          margin-top: 46px;
          p {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #480303;
            line-height: 64px;
            height: 64px;
            text-align: center;
            font-style: normal;
            margin-bottom: 20px;
          }
          p:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.box4 {
  padding: 80px 0 60px;
  width: 100%;
  background: #e2ebff;
  .content {
    background: url("../../../assets/coursePage/ai2/box4/bg01.png") no-repeat;
    background-size: cover;
    width: 664px;
    height: 1268px;
    margin: 48px auto 0;
    padding-top: 10px;
    box-sizing: border-box;
    .item {
      position: relative;
      width: 540px;
      height: 300px;
      margin: 0px 0 0 160px;
      box-sizing: border-box;
      padding-top: 46px;
      > i {
        position: absolute;
        left: 0;
        top: 40px;
      }
      > a {
        width: 526px;
        display: block;
        height: 80px;
        background: linear-gradient(180deg, #ff242e 0%, #ff8994 100%);
        border-radius: 48px;
        margin: 0 auto;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        line-height: 80px;
        text-align: center;
        font-style: normal;
      }
      > span {
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          font-size: 26px;
          color: #031748;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          margin-bottom: 20px;
        }

        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: normal;
          font-size: 24px;
          color: #031748;
          line-height: 34px;
          text-align: left;
          font-style: normal;
          display: flex;

          i {
            margin-right: 5px;
            display: block;
          }
          em {
            display: block;
            font-weight: normal;
          }
        }
      }
    }
    .item:nth-child(1){
      p{
        line-height: 40px;
      }
    }
    .item:nth-child(2) {
      padding: 0px 0 0 0;
    }
    .item:nth-child(3) {
      padding: 20px 0 0 0;
    }
    .item:nth-child(4) {
      padding: 10px 0 0 0;
      margin-left: 140px;
      height: 248px;
    }
    .item:nth-child(5) {
      padding: 0 0 0 0;
      margin-left: 106px;
    }
  }
}
</style>
